import * as angular from 'angular';
import * as _ from 'underscore';
import { IImgFileModel } from '../../directives/models';
import { AvatarService } from '../../services/avatar.service';
import { NotificationService } from '../../services/notification.service';

class JispPayAvatarComponent implements ng.IComponentController {
    public static $inject = ['notificationService', '$timeout', '$translate', 'avatarService'];

    public resolve: {
        getUrl: string;
        title: string;
        saveUrl: string;
        avatarId: number;
        imageSize?: {w: number, h: number};
        sizeText?: string;
        maxFileSizeMb?: number;
        aspectRatio?: number;
        fileExtensions?: string[];
        disableAspectRatio?: boolean;
    };

    public uploadText: string = this.$translate.instant('upload_photo_min_size_hint');
    public minSize = {
        w: 800,
        h: 800
    };

    public maxFileSizeMb = 20;
    public aspectRatio = 1;
    public fileExtensions: string[] = ['jpeg', 'jpg', 'png', 'bmp', 'gif'];
    public fileExtensionsText: string;
    public acceptExtensions = 'image/gif,image/png,image/jpeg,image/pjpeg,.bmp';

    private modalInstance: ng.ui.bootstrap.IModalInstanceService = this as any;
    private imageFile: File & IImgFileModel;
    private waiting: boolean = false;
    private error: string;

    private cropImage: string | ArrayBuffer = null;
    private croppedImage: string;

    private form: ng.IFormController & {
        fileInput: ng.INgModelController
    };

    private selector: {
        size: {
            w: number,
            h: number
        }
    };

    constructor(
        private notificationService: NotificationService,
        private $timeout: ng.ITimeoutService,
        private $translate: angular.translate.ITranslateService,
        private avatarService: AvatarService
    ) { }

    public $onInit() {
        this.fileExtensionsText = this.fileExtensions.join(', ');
        this.cropImage = this.resolve.avatarId
            ? this.resolve.getUrl
            : null;
        if (this.resolve.imageSize) {
            this.minSize = this.resolve.imageSize;
        }
        if (this.resolve.sizeText) {
            this.uploadText = this.resolve.sizeText;
        }
        if (this.resolve.maxFileSizeMb) {
            this.maxFileSizeMb = this.resolve.maxFileSizeMb;
        }
        if (this.resolve.aspectRatio) {
            this.aspectRatio = this.resolve.aspectRatio;
        }
        if (this.resolve.fileExtensions) {
            this.fileExtensions = this.resolve.fileExtensions;
            this.acceptExtensions = this.fileExtensions.map((extension) => '.' + extension).join(',');
        }
    }

    private close() { this.modalInstance.dismiss({ $value: 'cancel' }); }

    private async save() {
        this.waiting = true;
        try {
            if (this.resolve.saveUrl) {
                const avatarId = await this.avatarService.uploadImage({ dataUri: this.croppedImage }, this.resolve.saveUrl);
                this.notificationService.showSuccessMessage();
                this.modalInstance.close({ $value: avatarId });
            } else {
                this.modalInstance.close({$value: this.croppedImage });
            }
        } catch (error) {
            this.notificationService.showErrorMessage(error);
        }

        this.waiting = false;
    }

    private onCropped(cropped: string) {
        if (!this.cropImage || _.isEmpty(cropped)) {
            return;
        }

        this.croppedImage = cropped;
        if (!this.minSize || !this.selector.size) {
            return;
        }

        const isValidSize = this.selector.size.w >= this.minSize.w && this.selector.size.h >= this.minSize.h;
        this.form.fileInput.$setValidity('size', isValidSize);
        this.form.$pristine = false;
    }

    private onFileSelected() {
        if (this.imageFile.error) {
            this.error = this.imageFile.error;
            this.form.$invalid = true;
            return;
        }
        this.error = null;
        if (this.imageFile) {
            this.form.fileInput.$setDirty();
            const fileReader = new FileReader();
            fileReader.onload = async () => {
                await this.$timeout(100);
                this.cropImage = fileReader.result;
            };
            fileReader.readAsDataURL(this.imageFile);
        }
    }
}

angular.module('app.common').component('jispPayAvatar', {
    template: require('./jispPayAvatar.html'),
    controller: JispPayAvatarComponent,
    controllerAs: '$ctrl',
    bindings: {
        resolve: '<',
        close: '&',
        dismiss: '&'
    }
});



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/app.common/modules/common/components/jispPayAvatar/jispPayAvatar.component.ts